import { CelebrationsHolidayPageTemplate } from "./template";
import { useCelebrationsHolidayPage } from "./logic";

export const CelebrationsHolidayPage = () : JSX.Element => {
    const props = useCelebrationsHolidayPage();

    return (
        <CelebrationsHolidayPageTemplate {...props}/>
    )
}